import React from 'react';
import { Empty, Icon } from 'antd';
import styles from './index.module.scss';

const defaultImgSize = 50;

const createImgStyle = (imgSize) => ({
  height: imgSize,
  fontSize: imgSize,
});

const BaseError = ({ imgSize = defaultImgSize, ...props }) => {
  return (
    <Empty
      image={<Icon type="exclamation-circle" className={styles.icon} />}
      imageStyle={createImgStyle(imgSize)}
      {...props}
    />
  );
};

export default BaseError;
